function Box({ maze }) {
    return (
        // returning maze onto the screen
        maze.displayMaze()
    );
}

export default Box;